if (!customElements.get('cart-jewelry-carousel')) {
  customElements.define(
    'cart-jewelry-carousel',
    class CartJewelryCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cart-jewelry-carousel__track');
        this.prevButton = this.querySelector('.cart-jewelry-carousel__arrow--prev');
        this.nextButton = this.querySelector('.cart-jewelry-carousel__arrow--next');

        if (!this.track) return;

        this.prevButton?.addEventListener('click', () => this.goTo(-1));
        this.nextButton?.addEventListener('click', () => this.goTo(1));
      }

      goTo(direction) {
        const slides = Array.from(this.track.children);
        if (!slides.length) return;

        const slideWidth = slides[0].getBoundingClientRect().width;
        const trackStyle = getComputedStyle(this.track);
        const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
        const step = slideWidth + gap;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        let target = this.track.scrollLeft + step * direction;

        if (target > maxScroll - 2) {
          target = 0;
        } else if (target < 2 && direction < 0) {
          target = maxScroll;
        }

        this.track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
  );
}
